import styled from "styled-components";

export const ModalContent = styled.div`
  overflow: scroll;
  background-color: #fff;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const Filters = styled.div`
  color: #000FFF;
  font-size: 18px;
  font-weight: bold;
`;

export const ButtonDays = styled.div`
  width: 170px;
  height: 40px;
  color: #ffffff;
  padding: 10px 26px;
  background-color: #000FFF;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000066;

  @media (max-width: 768px) {
    width: 46%;
    height: 10%;
    color: #ffffff;
    padding: 0.5rem;
    background-color: #000FFF;
    border-radius: 8px;
    text-align: center;
    font-size: 0.94rem;
  }
`;

export const Period = styled.div`
  color: #707070;
  font-size: 1rem;
  margin-bottom: 11px;
`;

export const ButtonFilter = styled.button`
  background-color: #000FFF;
  color: #fff;
  font-size: 16px;
  box-shadow: 0px 3px 6px #00000066;
  border-radius: 10px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1.5rem 0 1rem 0;
  width: 100%;
  border: 0;
`;

export const Datefield = styled.div`
  width: 170px;
  font-size: 1.1rem;
  padding: 0.3rem 1rem;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  color: #8c8c8c;
  box-shadow: 0px 3px 6px #00000066;
  @media (max-width: 450px) {
    width: 8.5rem;
  }
`;

export const DivisionRadio = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 0 0 1rem 0;

  div {
    display: flex;
    align-items: center;
  }

  label {
    color: #707070;
    font-size: .9rem;
    margin: 0 0 0 .5rem;
  }

  @media(max-width: 770px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Bottom = styled.div`

`;

export const NumberInput = styled.input`
  width: 100%;
  font-size: 1.1rem;
  padding: 0.3rem 1rem;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  color: #8c8c8c;
  box-shadow: 0px 3px 6px #00000066;
`;

export const DivisionSeal = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 1rem 0;
`;
